export function removeSuffix(suffix: string | RegExp, str: string | undefined) {
  return str?.replace(suffix, '')
}
